<template>
  <div class="warp">
    <div class="company_heard_tool">
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="primary" size="mini" icon="el-icon-check" @click="agreeList">打款</el-button>
      <el-button type="primary" size="mini" icon="el-icon-close" @click="refuseList">拒绝</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="delList">删除</el-button>
    </div>
    <!-- 头部工具栏 -->
    <!-- 借支版块，预支申请记录添加一些筛选功能，用户手机，申请企业，打款状态，筛选功能，可以按筛选结果导出对应资料。 -->
    <el-form ref="screenForm" :inline="true" class="demo-form-inline">
      <el-form-item label="用户手机" prop="memberPhone">
        <el-input v-model="screenForm.memberPhone" />
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>

      <el-form-item label="打款状态">
        <el-select v-model="screenForm.remitStatus" placeholder="不限" clearable>
          <el-option label="无" :value="0" />
          <el-option label="待打款" :value="1" />
          <el-option label="已打款" :value="2" />
          <el-option label="取消打款" :value="3" />
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
      <exportexcel :info="tableData" />
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <!-- <el-table-column type="index" label="#" width="50" /> -->
        <el-table-column prop="memberPhone" label="用户手机" width="110" />
        <el-table-column label="申请企业" width="230" prop="companyName" />
        <el-table-column label="姓名" width="80">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.applicantName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" width="170">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.idCard }}</div>
          </template>
        </el-table-column>
        <el-table-column label="入职时间" width="100">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.entryTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="工资所属期" width="100">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.salaryPeriod }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="yuzhiApplyStatus" label="流程当前状态" width="280">
          <template slot-scope="scope">
            <div style="color: #606266; display: flex; justify-content: center; align-items: center">
              <div>{{ scope.row.yuzhiApplyStatus | yuzhiApplyStatus }}</div>
              <el-button style="margin-left: 10px" type="primary" @click="detail(scope.row.id)">流程详情</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="归属公司" width="90">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.attributionCompany }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remitStatus" label="打款状态">
          <template slot-scope="scope">
            <el-row>
              <div style="color: #606266; display: inline-block">{{ scope.row.remitStatus | remitStatus }}</div>
              <div v-if="scope.row.remitStatus === 1" style="display: inline-block; margin-left: 10px">
                <el-button type="primary" @click.stop="yuzhiAgree(scope.row.id)">打款</el-button>
                <el-button type="primary" @click.stop="yuzhiRefuse(scope.row.id)">拒绝</el-button>
              </div>
            </el-row>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="yuzhiAmount" label="预支金额" width="110" /> -->
        <el-table-column prop="name" label="预支信息">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.name }} {{ scope.row.idCard }}</div>
            <div style="color: #606266">{{ scope.row.bankName }} {{ scope.row.bankCard }}</div>
            <div style="color: #606266">
              预支金额: <span style="color: white; background-color: rgb(211, 74, 64)">{{ scope.row.yuzhiAmount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" width="100">
          <template slot-scope="scope">
            <div style="color: #606266">{{ scope.row.createDate }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[100, 200, 500, 1000]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="流程详情" width="500px" :visible="visible" @close="visible = false">
      <el-steps direction="vertical" :active="steps.length" space="20">
        <el-step v-for="(item, index) in steps" :key="index" :title="item.title" :description="item.content">
          <template slot="description">
            <div>{{ item.content }}</div>
            <div>{{ item.date }}</div>
          </template>
        </el-step>
      </el-steps>
    </el-dialog>
  </div>
</template>
<script>
import exportexcel from '@/components/ExportExcel'
import pagination from '@/mixins/pagination'
import md5 from 'js-md5' // 引入Md5加密
import { deepClone } from '@/utils'

import { yuzhiApplyAgree, yuzhiApplyRefuse } from '@/api/yuzhi'
export default {
  filters: {
    remitStatus(status) {
      const statusObj = {
        0: '无',
        1: '待打款',
        2: '已打款',
        3: '取消打款'
      }
      return statusObj[status]
    }
  },
  components: { exportexcel },
  mixins: [pagination],
  data() {
    return {
      tableData: [],
      tableH: 0,
      screenForm: {
        companyName: '',
        memberPhone: '',
        name: '',
        remitStatus: null
      },
      type: [],
      steps: [],
      visible: false,
      multipleSelection: [],
      pageNumber: 1,
      pageSize: 100
    }
  },
  mounted() {
    this.page.pageSize = 100
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量打款
    agreeList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('你并没有选中任何用户')
      }
      var ids = []
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      console.log(ids)
      var params = {
        ids: ids.toString()
      }
      this.$api.advance
        .agreeList(params)
        .then((res) => {
          console.log(res)
          this.$message.success(res)
          this.refresh()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 批量拒绝
    refuseList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('你并没有选中任何用户')
      }
      var ids = []
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      console.log(ids)
      var params = {
        ids: ids.toString()
      }
      this.$api.advance
        .refuseList(params)
        .then((res) => {
          console.log(res)
          this.$message.success(res)
          this.refresh()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 批量删除
    delList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('你并没有选中任何用户')
      }
      var ids = []
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      console.log(ids)
      var params = {
        ids: ids.toString()
      }
      this.$api.advance
        .deleteList(params)
        .then((res) => {
          console.log(res)
          this.$message.success(res)
          this.refresh()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 当页显示的条数
    handleSizeChange(e) {
      console.log(e)
      this.pageSize = e
      this.getTableList()
    },
    getTableList() {
      this.loading = true
      console.log(this.page)
      this.$api.advance
        .applyList(this.page)
        .then((res) => {
          console.log(res)
          // console.log(this.page,"输出的page")
          this.tableData = res.records
          const comIds = res.records
            .map((item) => item.companyId)
            .filter((id) => id)
            .join(',')
          this.getCompanyNameByIds({ ids: comIds })
          const ids = res.records.map((item) => item.memberId).join(',')
          this.getMemberByIds({ ids })
          this.total = res.total
          this.loading = false
        })
        .catch((e) => {})
    },
    getMemberByIds(data) {
      return this.$api.member
        .reqMemberByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'memberPhone', res[item.memberId] && res[item.memberId].phone)
            this.$set(item, 'memberName', res[item.memberId] && res[item.memberId].name)
          })
          this.loading = false
        })
        .catch(() => {})
    },
    getCompanyNameByIds(data) {
      return this.$api.company
        .reqCompanyByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'companyName', res[item.companyId] && res[item.companyId].companyName)
          })
        })
        .catch(() => {})
    },
    detail(id) {
      this.$api.advance.progress({ id: id }).then((res) => {
        this.visible = true
        this.steps = res
      })
    },
    refresh() {
      this.page = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
      this.$refs.screenForm.resetFields()
      this.getTableList()
    },
    screenData() {
      this.page = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
      Object.assign(this.page, this.screenForm)
      this.getTableList()
    },
    accept(id) {
      this.$api.advance
        .accept({ id })
        .then((res) => {
          Object.assign(this.page, this.screenForm)
          this.getTableList()
        })
        .catch((e) => {})
    },
    reject(id) {
      this.$api.advance
        .reject({ id })
        .then((res) => {
          Object.assign(this.page, this.screenForm)
          this.getTableList()
        })
        .catch((e) => {})
    },
    // 预支同意
    yuzhiAgree(id) {
      this.$confirm('是否同意该员工预支申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          yuzhiApplyAgree({
            id: id
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '打款成功!'
            })
            console.log('执行？？')
            console.log('查看信息')
            this.getTableList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 预支拒绝
    yuzhiRefuse(id) {
      this.$confirm('是否拒绝该员工预支申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          yuzhiApplyRefuse({
            id: id
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '已拒绝!'
            })
            this.getTableList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
